import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { InstallPromptProvider } from "./InstallPromptContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <InstallPromptProvider>
      <App />
    </InstallPromptProvider>
  </React.StrictMode>
);
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(() => console.log("SW registered"))
      .catch((err) => console.error("SW register failed:", err));
  });
}

// Register SW in production; reload on update
    
  
